import React, {useEffect, useState} from 'react'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { useQuery } from 'react-query';
import apiClient from '../../request/http-common';
import { Fragment } from 'react';
import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import {MiniChart} from "react-ts-tradingview-widgets";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { CardActions } from '@mui/material';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import WalletButton from '../Wallet/WalletButton';
import { useSelector } from 'react-redux';
import WithdrawalButton from '../Withdrawal/WithdrawalButton';
import EarningAnalysis from '../Earning/EarningAnalysis';
import Cards from '../Cards/Cards';
import { useDispatch } from 'react-redux';
import { setcurrentPair, setPairType } from '../Trader/tradingSlice';
import { useNavigate } from 'react-router-dom';
import CandlestickChartIcon from '@mui/icons-material/CandlestickChart';


const ListStock = () => {

    const stock = useSelector((state) => state.coins.stock);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const appMode = useSelector((state) => state.mode.mode);
    const formatPrice = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'standard' }).format(amount);

  return (
      <div>
        {/* <Typography mb={1}  ml={3} mt={4} sx={{ fontWeight: 'bold', fontSize: 20, textTransform: 'uppercase', textAlign: 'center'  }} gutterBottom variant="h6" component="div">
                TRADE STOCK MARKET
        </Typography>
        <Typography  sx={{textAlign: 'center'}} variant="body2" color="text.secondary">
                kindly click any asset pair to trade
        </Typography> */}

        {stock.length < 1 &&
        <CircularProgress/>
        }
        {stock.length > 0 && 

        <List sx={{ width: '100%', bgcolor: 'background.paper' }}>

            {stock.map((coin) =>(
                <Fragment key={coin.short_name}>
                <ListItem alignItems="flex-start" sx={{cursor: 'pointer', alignItems: 'center'}}
                onClick={()=>{
                  dispatch(setcurrentPair(`${coin.short_name}`));
                  dispatch(setPairType('stocks'));
                                    
                  setTimeout(() => {
                    navigate('/trading-page');
                  }, 100);
              }}
                >
          <ListItemAvatar>
          {/* IMAGE */}
          <Avatar alt={coin.short_name}
            src={`https://img.logo.dev/ticker/${coin.short_name}?token=pk_Pb2cclXnTuuh7Lsj1Ys7ew&retina=true`}
            />
        </ListItemAvatar>
                <ListItemText
                  primary={coin.short_name}
                  secondary={
                    <React.Fragment>
                      <Typography
                        sx={{ display: 'inline' }}
                        component="span"
                        variant="body2"
                        color="text.primary"
                      >
                        {coin.name}
                      </Typography>
                    </React.Fragment>
                  }
                />


                {/* <Box edge="end" sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignContent: 'flex-start', alignItems: 'flex-start'}}>
                <Typography sx={{fontWeight: 'bolder'}} >
                {coin.exch}
                </Typography>
                <Typography mt={1}>
                <Button
                onClick={()=>{
                    if (coin.symbol === 'USDT') {
                      dispatch(setcurrentPair(`${coin.exch}:${coin.short_name}`));
                    }else{
                      dispatch(setcurrentPair(`${coin.exch}:${coin.short_name}`));
                    }                    
                    setTimeout(() => {
                      navigate('/start-trading-stock');
                    }, 100);
                }}

                fullWidth={false} edge="end" size="small" color="primary" variant="contained"> 
                trade
                </Button>
                </Typography>
                </Box> */}


                <Box edge="end" sx={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignContent: 'flex-start', alignItems: 'flex-start'}}>
                    <Typography mx={1}>
                    {formatPrice(coin.priceUsd)}
                    </Typography>
                </Box>


                <Box edge="end" sx={{marginTop: '10px'}}>
                    <Button style={{fontSize: '14px', fontWeight: 'bolder'}} color={parseFloat(coin.change_price) > 0 ? 'success' : 'error'} variant="contained" size="small">
                   {parseFloat(coin.change_price) > 0 && '+'} {coin.change_percentage} 
                    </Button>
                </Box>

              </ListItem>
              <Divider variant="inset" component="li" />
              
              </Fragment>
            ))}  
      </List>
        
        }
      
    </div>
  )
}

export default ListStock
